'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var moment = require('moment-timezone');
var polyglot = require('../utilities/polyglot').default;

export default Backbone.Model.extend({

  toJSON: function () {
    var json = Backbone.Model.prototype.toJSON.call(this);
    json.full_address = this.getFullAddress();

    var open, close, hasHours = false;
    var days = _.map(moment.localeData('en')._weekdays, function (day) {
      return day.toLowerCase();
    });
    for (var i = 0; i < days.length; i++) {
      if (this.get(days[i] + '_open') && this.get(days[i] + '_closed')) {
        hasHours = true;
        open = moment(this.get(days[i] + '_open'), 'HH:mm:ss');
        close = moment(this.get(days[i] + '_closed'), 'HH:mm:ss');

        json[days[i] + '_hours'] = open.format('LT') + ' - ' + close.format('LT');
      } else {
        json[days[i] + '_hours'] = polyglot.t('location.closed');
      }
    }
    json.hasHours = hasHours;

    return json;
  },

  distanceFromPoint: function (latitude, longitude) {
    var lat1 = this.get('latitude'),
      lat2 = latitude,
      lon1 = this.get('longitude'),
      lon2 = longitude;

    var R = 6371; // Radius of the earth in km
    var dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a =
      0.5 - Math.cos(dLat) / 2 +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      (1 - Math.cos(dLon)) / 2;

    return R * 2 * Math.asin(Math.sqrt(a));
  },

  hasService: function (service) {
    return _.some(this.get('service'), function (id) {
      return id === service.id;
    });
  },

  hasAllServices: function (services) {
    return _.every(services, _.bind(this.hasService, this));
  },

  hasStaff: function (staff) {
    return _.some(this.get('staff'), function (id) {
      return id === staff.id;
    });
  },

  getFullAddress: function () {
    var address = '';

    if (!this.get('virtual')) {
      if (this.get('formatted_address') == null) {
        address = this.get('address');
        address += '<br />' + this.get('city');
        address += this.get('prov_state') ?  ', ' + this.get('prov_state') : '';
        address += ', ' + this.get('postal_zip');
        address += '<br />' + this.get('country');
      } else {
        address = this.get('formatted_address');
      }
    }

    return address;
  },

  getTimezone: function () {
    return this.get('timezone');
  },

  isVirtual: function () {
    return this.get('virtual');
  },

  isOpen: function () {
    const timezone = this.get('timezone');
    const now = moment().tz(timezone).locale('en');
    const day = now.format('dddd').toLowerCase();
    const openTime = moment(this.get(`${day}_open`), 'HH:mm:ss').tz(timezone);
    const closedTime = moment(this.get(`${day}_closed`), 'HH:mm:ss').tz(timezone);

    return openTime.diff(now) < 0 && closedTime.diff(now) > 0;
  },

  shouldShowWaitTime: function () {
    return this.isOpen() && !this.isVirtual();
  },

});
